const translations = {
  "en": {
    "Member already exists.": "Member already exists.",
    "No product ID found.": "No product ID found.",
    "Payment is only available in App environment.": "Payment is only available in App environment.",
    "Please review the terms and try again.": "Please review the terms and try again.",
    "Purchase failed.": "Purchase failed.",
    "This plan isn't available in the app.": "This plan isn't available in the app.",
    "This product is not available for in-app purchase.": "This product is not available for in-app purchase.",
    "Too many attempts. Please try again in a minute.": "Too many attempts. Please try again in a minute.",
    "You already have an active subscription with another payment method. Please cancel it before making a new purchase.": "You already have an active subscription with another payment method. Please cancel it before making a new purchase.",
    "Your device/OS doesn't support in-app purchases. Please upgrade your system or update Google Play and try again.": "Your device/OS doesn't support in-app purchases. Please upgrade your system or update Google Play and try again."
  },
  "zh-tw": {
    "Member already exists.": "成員已存在。",
    "No product ID found.": "找不到產品 ID。",
    "Payment is only available in App environment.": "付款僅可在應用程式環境中進行。",
    "Please review the terms and try again.": "請檢視條款並重試。",
    "Purchase failed.": "購買失敗。",
    "This plan isn't available in the app.": "此方案無法於 App 中使用。",
    "This product is not available for in-app purchase.": "此產品無法透過應用程式內購買。",
    "Too many attempts. Please try again in a minute.": "嘗試次數過多。請一分鐘後再試。",
    "You already have an active subscription with another payment method. Please cancel it before making a new purchase.": "您已透過其他付款方式擁有有效訂閱。請於購買新方案前取消該訂閱。",
    "Your device/OS doesn't support in-app purchases. Please upgrade your system or update Google Play and try again.": "你的裝置/作業系統不支援應用程式內購買。請升級系統或更新 Google Play 後再試一次。"
  }
};

export default translations;
